import { render, staticRenderFns } from "./TwoColumnBlock.vue?vue&type=template&id=36932ddf&scoped=true&"
import script from "./TwoColumnBlock.vue?vue&type=script&lang=js&"
export * from "./TwoColumnBlock.vue?vue&type=script&lang=js&"
import style0 from "./TwoColumnBlock.vue?vue&type=style&index=0&id=36932ddf&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36932ddf",
  null
  
)

export default component.exports